/*
 * @Author: youfanrong 737064439@qq.com
 * @Date: 2025-04-21 14:32:45
 * @LastEditors: youfanrong 737064439@qq.com
 * @LastEditTime: 2025-12-05 10:40:15
 * @FilePath: /bar-front-end/src/api/boothList/index.ts
 */
import request from '@/axios'

// 获取全量座位分页列表
export const getBoothListApi = (params: any = {}) => {
  return request.get({ url: '/barV2/front/booth/page', params })
}

// 预定登记(手动定卡)-开台
export const getBoothBookingListApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/booking', data })
}

// 预定登记分页列表
export const getBoothBookingOrderPageApi = (params: any) => {
  return request.get({ url: '/barV2/front/booth/bookingOrderPage', params })
}

// 预定登记审核
export const getBoothBookingOrderAuditApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/bookingOrderAudit', data })
}

// 获取座位区域分页列表--------
export const getBoothAreaListApi = (params: any = {}) => {
  return request.get({ url: '/barV2/console/boothArea/page', params })
}

// 获取座位类型分页列表------
export const getBoothTypeListApi = (params: any = {}) => {
  return request.get({ url: '/barV2/console/boothType/page', params })
}

// 锁台
export const getBoothLockApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/lock', data })
}

// 开台
export const getBoothOpenApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/open', data })
}

// 解锁
export const getBoothUnlockApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/unlock', data })
}

// 清台
export const getBoothCleanApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/clean', data })
}

// 根据手机号获取客户信息
export const getCustByPhoneNumberApi = (params: any) => {
  return request.get({ url: '/barV2/front/cust/getCustByPhoneNumber', params })
}

// 根据手机号获取客户信息
export const getCustSimpleListApi = (params: any) => {
  return request.get({ url: '/barV2/front/cust/getCustSimpleList', params })
}

// 获取座位操作日志分页列表
export const getBoothOperLogPageApi = (params: any) => {
  return request.get({ url: '/barV2/front/boothOperLog/page', params })
}

// 发送验证码到手机
export const sendCaptchaToPhoneApi = (params: any) => {
  return request.get({ url: '/barV2/front/cust/sendCaptchaToPhone', params })
}

// 系统用户列表(不分页)
export const getUserListApi = (params: any) => {
  return request.get({ url: '/barV2/front/user/sysUserList', params })
}

// 获取客户详情
export const getCustDetailByIdApi = (params: any) => {
  return request.get({ url: '/barV2/front/cust/getCustDetailById', params })
}

// 更新订位人
export const updateBookerApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/updateBooker', data })
}

// 转台
export const getBoothTransferApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/transfer', data })
}

// 换台
export const getBoothExchangeApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/exchange', data })
}

// 复台
export const getBoothRecoverApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/recover', data })
}

// --------------------------------------------------
// 预约申请分页列表
export const getBoothBookingApplyPageApi = (params: any) => {
  return request.get({ url: '/barV2/front/booth/bookingApply/page', params })
}

// 预约申请分享
export const getBoothBookingApplyShareApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/bookingApply/share', data })
}

// 预约申请提交
export const getBoothBookingApplySubmitApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/bookingApply/submit', data })
}

// 预约申请审核
export const getBoothBookingApplyAuditApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/bookingApply/audit', data })
}

// 取消预约申请
export const getBoothBookingApplyCancelApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/bookingApply/cancel', data })
}

// 获取商品列表
export const getDrinkOrderListApi = () => {
  return request.get({ url: '/barV2/front/drink/orderList' })
}

// 提交订单
export const getPreOrderOrderApi = (data: any) => {
  return request.post({ url: '/barV2/front/preOrder/order', data })
}

// 预约登记取消
export const getBoothBookingOrderCancelApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/bookingOrderCancel', data })
}

// 预约申请分享图片生成
export const getBoothBookingApplyShareImageApi = (data: any) => {
  return request.post({
    url: '/barV2/front/booth/bookingApply/shareImage',
    data,
    responseType: 'blob'
  })
}

// 上传图片文件
export const uploadImageApi = (data: FormData) => {
  return request.post({
    url: '/barV2/front/common/uploadImage',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 卡座订台表 
export const getBoothBookPageApi = (params: any) => {
  return request.get({ url: '/barV2/front/booth/boothBookPage', params })
}

// 获取默认客户
export const getCustDefaultApi = (params: any) => {
  return request.get({ url: '/barV2/front/cust/getDefaultCust', params })
}

// 是否默认客户
export const isDefaultCustApi = (params: any) => {
  return request.get({ url: '/barV2/front/cust/isDefaultCust', params })
}

// 获取默认用户
export const getUserDefaultApi = (params: any) => {
  return request.get({ url: '/barV2/front/user/getDefaultUser', params })
}

// 修改低消
export const updateMinConsumeApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/updateMinConsume', data })
}

// 批量清台
export const getBoothCleanBatchApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/cleanBatch', data })
}

//通过卡座获取订位人和客户信息 
export const getBoothMatchBookerAndCustByBoothApi = (params: any) => {
  return request.get({ url: '/barV2/front/booth/matchBookerAndCustByBooth', params })
}

// 打印所有结账单
export const printAllCheckoutOrderApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/printAllCheckoutOrder', data })
}

// 预约申请编辑 /barV2/front/booth/bookingApply/edit
export const getBoothBookingApplyEditApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/bookingApply/edit', data })
}

// 获取卡座已结束预订单列表 /barV2/front/booth/endedBookOrderList
export const getBoothEndedBookOrderListApi = (params: any) => {
  return request.get({ url: '/barV2/front/booth/endedBookOrderList', params })
}

// 根据预订单复台 /barV2/front/booth/recoverByBookOrder
export const getBoothRecoverByBookOrderApi = (data: any) => {
  return request.post({ url: '/barV2/front/booth/recoverByBookOrder', data })
}